import React, {useState }from "react";
import auth from "../../auth";
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import Icon from '../../images/Stormwater2.jpg';
import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'
import Background from '../../images/roanokeskyline.jpg';

export const Landing = props => {

    const [userPassword, setUserPassword] = useState('accept')
    const [authMessage, setAuthMessage] = useState('')

    const authSuccess = () => {
        setAuthMessage('');
        props.history.push("/private")
    }

    const authFail = () => {
        setAuthMessage('please enter a valid password');
    }

    const loginUser = (e) => {
        e.preventDefault();
        auth.login(userPassword, authSuccess, authFail);
    };

    return (
        <div id="landingWrapper" style={{ backgroundImage: `url(./` + Background + `)`}} >
            <Navbar className="landingCustomNavbar" collapseOnSelect expand="lg" variant="dark">
                <Navbar.Brand href="https://www.roanokeva.gov/500/Stormwater" target="_blank">
                    <img id="navIcon" src={`./` + Icon} alt="stormwater logo"></img>
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                <Navbar.Collapse id="responsive-navbar-nav">
                    <Nav className="mr-auto">
                        <span id="landingNavMainline">City of Roanoke <p id="landingNavSub">STORMWATER UTILITY</p></span>
                        <span id="landingNavTagline">Real Time Flood Inundation Application</span>
                    </Nav>
                </Navbar.Collapse>
            </Navbar>


            <div id="landingContent">
                <div id="disclaimer">
                    <h3 id="disclaimerTitle">Welcome to the City of Roanoke Real-time Flood Inundation Mapping Application</h3>
                    <p>                                        
                            This application was developed by the City of Roanoke Stormwater Department as a tool to assist City staff and first responders with situational awareness and response to current and forecasted flooding conditions along the Roanoke River.                    
                    </p>
                    <p>
                            This tool uses measured river stage values from the USGS gaging station 02055000 located at Walnut Ave over the Roanoke River.  River stage values are updated every 5 minutes by the USGS, however, there may be some delay before values are shown in this system.  Forecasted river stage values (when available) are obtained from the National Weather Service River Forecast Center and are updated approximately every 6 hours.   Flood inundation boundaries shown are developed from the 1D, steady state hydraulic model for the Roanoke River and reflect unobstructed flow conditions as modeled.  Building depth values are estimates based on available elevation certificates, LIDAR and other GIS datasets.  
                    </p>
                    <p>
                            Localized factors may lead to differences in the inundation extents shown on this site compared to actual observed flood inundation extents.  The flood inundation shown on this application should be used for information purposes only and should be considered 'as-is' for quick reference and planning.  By entering this site and clicking on accept below you agree that the City of Roanoke is not responsible for the use or misuse of this data.
                    </p>
                    <p>
                            All data are provisional and subject to change. This data is not intended to be used for any insurance purposes.
                    </p>
                </div>
       
                <Form onSubmit={loginUser}>
                    <Form.Group id="passwordField" controlId="formHorizontalPassword">
                        <Button id="loginButton" type="submit" variant="outline-light" size="sm" >Accept</Button>
                    </Form.Group>

                    <p><small>{authMessage}</small></p>

                </Form>
            </div>
        </div>
    );
};


export default Landing;


// WEBPACK FOOTER //
// ./src/pages/Landing/index.js